import {
  Container,
  Box,
  Alert,
  Snackbar,
  Backdrop,
  CircularProgress,
  Typography,
  Paper,
  Icon,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  InputAdornment,
  TextField,
  MenuItem,
  Grid,
  Divider,
  LinearProgress,
  Card,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CheckoutFooter from "../components/footer";
import AppConfig from "../../appConfig";
import axios from "../../axios";
import usePageTitle from "../pageTitle";
import FormSectionBuilder from "../components/data_forms/form_section_builder";
import { useGeolocated } from "react-geolocated";

function DataCapturePage() {
  const [pageTitle, setPageTitle] = useState("Data Capture");
  usePageTitle(pageTitle);

  const { ref } = useParams();
  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [banner, setBanner] = useState(null);
  const [campaign, setCampaign] = useState(null);
  const [presetAmount, setPresetAmount] = useState(null);
  const [dataForm, setDataForm] = useState(null);
  const [dataFormSections, setDataFormSections] = useState([]);
  const [selectedAmount, setAmount] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState(null);

  const [statusMsg, setStatusMsg] = useState("");
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
  const [openErrorDialog, setOpenErrorDialog] = useState(false);

  const [sellResult, setSellResult] = useState(null);
  const [showInlineLoading, setShowInlineLoading] = useState(false);

  const [renderCount, setRenderCount] = useState(0);
  let step = 0;

  useEffect(() => {
    if (ref === null) {
      navigate("/error");
      alert("NONE");
      return;
    }

    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`data_captures/${ref}/fetch.json`)
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            // console.log(result.data.data);
            setBanner(result.data.data.banner);
            setCampaign(result.data.data.campaign);
            setDataForm(result.data.data.campaign.data_form);
            setPresetAmount(result.data.data.preset_amount);
            if (result.data.data.preset_amount !== null) {
              if (result.data.data.preset_amount.amount_type === "FIXED") {
                setAmount(result.data.data.preset_amount.amount / 100);
              }
            }
            setPageTitle(
              `${result.data.data.campaign.account.name} | ${result.data.data.campaign.title}`
            );

            // Handle App Update
            const currentVersion = localStorage.getItem(
              AppConfig.app_version_store
            );
            const newVersion = result.data.version;
            if (currentVersion !== newVersion) {
              localStorage.setItem(AppConfig.app_version_store, newVersion);
              if (
                window.confirm("New version available. Reloading...") === true
              ) {
                window.location.reload(true);
              } else {
                window.location.reload(true);
              }
              return;
            }
          } else {
            // setSeverity("error");
            // setErrMsg(result.data.data.message);
            // setOpen(true);
            navigate("/error");
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine
                ? ""
                : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  // useEffect(() => {
  //   const sections = [];
  //   if (dataForm === null) {
  //     return;
  //   }

  //   dataForm.form.form.sections.every(async (formSection) => {
  //     // console.log(param.reference);
  //     let sect = (
  //       <Box mt={5} mb={3}>
  //         <Paper elevation={3}>
  //           <Box px={3} py={3}>
  //             <FormSectionBuilder
  //               section={formSection}
  //               logic={dataForm.form.form.navigation_logic}
  //             />
  //           </Box>
  //         </Paper>
  //       </Box>
  //     );
  //     if (
  //       formSection.reference in dataForm.form.form.navigation_logic.listeners
  //     ) {
  //       const listener =
  //         dataForm.form.form.navigation_logic.listeners[formSection.reference];
  //       let wID = `t_watcher_${listener.type}_${formSection.reference}`;

  //       const parentField = document.getElementById(`dff_${listener.trigger}`);
  //       if (parentField !== null) {
  //         sect = (
  //           <div id={`${wID}`} style={{ display: "none" }}>
  //             {sect}
  //           </div>
  //         );
  //         parentField.addEventListener("change", function () {
  //           const d = document.getElementById(wID);
  //           if (parentField.value !== listener.control) {
  //             d.style.display = "none";
  //             formSection.fields.every((fld) => {
  //               document.getElementById(`dff_${fld.reference}`).value = null;
  //               return false;
  //             });
  //           } else {
  //             d.style.display = "block";
  //           }
  //         });
  //       }
  //     }
  //     sections.push(sect);
  //     return false;
  //   });
  //   // console.log(sections);
  //   setDataFormSections(sections);
  // }, [dataForm]);

  // useEffect(() => {
  //   if (dataForm === null) {
  //     return;
  //   }

  //   dataForm.form.form.sections.every((formSection) => {
  //     if (
  //       formSection.reference in dataForm.form.form.navigation_logic.listeners
  //     ) {
  //       const listener =
  //         dataForm.form.form.navigation_logic.listeners[formSection.reference];
  //       const parentField = document.getElementById(`dff_${listener.trigger}`);
  //       if (parentField !== null) {
  //         const wID = `t_watcher_${listener.type}_${formSection.reference}`;
  //         parentField.addEventListener("change", function () {
  //           const d = document.getElementById(wID);
  //           if (parentField.value !== listener.control) {
  //             d.style.display = "none";
  //             formSection.fields.every((fld) => {
  //               document.getElementById(`dff_${fld.reference}`).value = null;
  //               return false;
  //             });
  //           } else {
  //             d.style.display = "block";
  //           }
  //         });
  //       }
  //       return false;
  //     }
  //   });
  //   console.log("WE GOO");
  // }, [dataForm]);

  const { coords, isGeolocationAvailable, isGeolocationEnabled } =
    useGeolocated({
      positionOptions: {
        enableHighAccuracy: true,
      },
      userDecisionTimeout: 5000,
    });

  function getGPSCoords() {
    if (!isGeolocationAvailable) {
      return false;
    }

    if (!isGeolocationEnabled) {
      return false;
    }

    if (coords) {
      return { latitude: coords.latitude, longitude: coords.longitude };
    }

    return false;
  }

  function getFormFieldDisplayName(fieldRef) {
    if (dataForm === null) {
      return "Unknown field";
    }

    let dName = "";
    dataForm.form.form.sections.every((section) => {
      section.fields.every((field) => {
        if (field.reference === fieldRef) {
          dName = `${field.display_name} (${section.title})`;
        }
        return true;
      });
      return true;
    });

    return dName ? dName : false;
  }

  function preprocessDataForm() {
    /* eslint-disable no-restricted-syntax */

    const dForm = document.querySelector(`#dataForm`);
    const formData = new FormData(dForm);
    const values = Object.fromEntries(formData.entries());
    // console.log(values);

    // for (const entry of formData.entries()) {
    //   if (entry[1].length <= 0) {
    //     setSeverity("error");
    //     const dF_fieldName = getFormFieldDisplayName(entry[0]);
    //     if (dF_fieldName === false) {
    //       continue;
    //     }
    //     setErrMsg(`${dF_fieldName} is required`);
    //     setOpen(true);
    //     return false;
    //   }
    // }

    let exludedName = "";
    let excluded = false;

    dataForm.form.form.sections.every((section) => {
      const ex = section.fields.every((field) => {
        if (!field.is_optional) {
          if (
            !formData.has(field.reference) ||
            values[field.reference].length <= 0
          ) {
            excluded = true;
            exludedName = `${field.display_name} (${section.title})`;
            return false;
          }
        }
        return true;
      });

      return ex;
    });

    if (excluded === true) {
      setSeverity("error");
      setErrMsg(`${exludedName} is not provided.`);
      setOpen(true);
      return false;
    }

    return values;
  }

  async function capture() {
    const gpsCoords = getGPSCoords();
    // console.log(gpsCoords);
    if (!gpsCoords) {
      setSeverity("error");
      setErrMsg("Please enable and allow browser's location and GPS access.");
      setOpen(true);
      return;
    }

    let dataFormValues = {};
    if (dataForm !== null) {
      const values = preprocessDataForm();
      if (values === false) {
        return;
      }
      dataFormValues = values;
    } else {
      setSeverity("error");
      setErrMsg("Data form not initialized. Select a campaign to proceed.");
      setOpen(true);
      return;
    }
    // console.log(dataFormValues);

    let pAmount = selectedAmount;
    if (presetAmount !== null) {
      const amt = parseInt(selectedAmount, 10);
      if (presetAmount.amount_type === "VARIABLE") {
        if (presetAmount.minimum_amount) {
          if (amt < presetAmount.minimum_amount / 100) {
            setSeverity("error");
            setErrMsg("Amount cannot be less than the minimum amount.");
            setOpen(true);
            return;
          }
        }

        if (presetAmount.maximum_amount) {
          if (amt > presetAmount.maximum_amount / 100) {
            setSeverity("error");
            setErrMsg("Amount cannot exceed the maximum amount.");
            setOpen(true);
            return;
          }
        }

        pAmount = amt * 100;
      }

      if (paymentMethod === null) {
        setSeverity("error");
        setErrMsg("Payment method is required.");
        setOpen(true);
        return;
      }
    }

    if (window.confirm("Are you sure you want to proceed?") === false) {
      return;
    }

    setShowLoading(true);
    const json = {
      reference: ref,
      campaign: campaign.reference,
      form: dataForm.reference,
      data: dataFormValues,
      latitude: gpsCoords.latitude,
      longitude: gpsCoords.longitude,
      amount: pAmount,
      payment_method: paymentMethod,
    };

    await axios
      .post("data_captures/capture.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          // console.log(result.data.data);
          if (result.data.data.status === "success") {
            setErrMsg(result.data.data.message);
            setStatusMsg(result.data.data.message);
            setOpenSuccessDialog(true);
          } else {
            // if (result.data.data.type === "display") {
            // } else {
            //   window.location.href = result.data.data.redirect_url;
            // }
            setSellResult(result.data.data);
          }
        } else {
          // setSeverity("error");
          // setErrMsg(result.data.data.message);
          // setOpen(true);

          setStatusMsg(result.data.data.message);
          setOpenErrorDialog(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setStatusMsg("An unexpected error occurred. Please try again later.");
        setOpenErrorDialog(true);
      });
  }

  async function checkPayment(captureRef) {
    setShowInlineLoading(true);
    await axios
      .get(`data_captures/${captureRef}/status.json`)
      .then((result) => {
        setShowInlineLoading(false);
        if (result.data.status === "success") {
          // console.log(result.data.data);
          if (result.data.data.status === "success") {
            setSellResult(null);

            setErrMsg(result.data.data.message);
            setStatusMsg(result.data.data.message);
            setOpenSuccessDialog(true);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setStatusMsg("An unexpected error occurred. Please try again later.");
        setOpenErrorDialog(true);
      });
  }

  return (
    <>
      <Box mb={5}>
        <Container>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={showLoading}
            onClick={handleClose}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
          <Snackbar
            open={open}
            autoHideDuration={6000}
            onClose={handleClose}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <Alert
              onClose={handleClose}
              severity={severity}
              sx={{ width: "100%" }}
            >
              {errorMsg}
            </Alert>
          </Snackbar>
          {sellResult && (
            <Dialog open fullWidth maxWidth="sm">
              <DialogContent>
                <Box p={1}>
                  <Box align="center">
                    {sellResult.type === "display" ? (
                      <Box>
                        <Typography variant="h4" fontWeight="light">
                          {sellResult.caption}
                        </Typography>
                        <Typography mt={1} variant="h3" fontWeight="medium">
                          <small>{sellResult.currency}</small>
                          {(sellResult.debit_amount / 100).toLocaleString(
                            "en",
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }
                          )}
                          {sellResult.debit_amount > sellResult.amount && (
                            <Typography fontWeight="light">{`${
                              sellResult.currency
                            }${(sellResult.fee / 100).toLocaleString("en", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })} fee incl.`}</Typography>
                          )}
                        </Typography>
                        <Box align="center" mb={3}>
                          <Typography variant="h6" fontWeight="regular">
                            {sellResult.instructions}
                          </Typography>
                        </Box>
                        <Divider />
                        <Box mt={2} mb={2} align="center">
                          {sellResult.instrument.map((record) => (
                            <Grid container spacing={0}>
                              <Grid item xs={6} md={6} lg={6}>
                                <Box align="left">
                                  <Typography
                                    variant="h6"
                                    fontWeight="light"
                                    fontSize={18}
                                  >
                                    <b>{record.key}:</b>
                                  </Typography>
                                </Box>
                              </Grid>
                              <Grid item xs={6} md={6} lg={6}>
                                <Box align="right">
                                  <Typography
                                    variant="h6"
                                    fontWeight="light"
                                    fontSize={18}
                                  >
                                    {record.value}
                                  </Typography>
                                </Box>
                              </Grid>
                            </Grid>
                          ))}
                        </Box>
                        <Divider />
                        <Box mt={3} align="center">
                          <Typography variant="h6" fontWeight="bold">
                            {sellResult.notes}
                          </Typography>
                        </Box>
                      </Box>
                    ) : (
                      <Box>
                        <Typography variant="h6" fontWeight="light">
                          {sellResult.caption}
                        </Typography>
                        <Typography mt={1} variant="h3" fontWeight="medium">
                          <small>{sellResult.currency}</small>
                          {(sellResult.debit_amount / 100).toLocaleString(
                            "en",
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }
                          )}
                          {sellResult.debit_amount > sellResult.amount && (
                            <Typography fontWeight="light">{`${
                              sellResult.currency
                            }${(sellResult.fee / 100).toLocaleString("en", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })} fee incl.`}</Typography>
                          )}
                        </Typography>
                        <Box mt={2} align="center" mb={3}>
                          <Typography
                            variant="h6"
                            fontWeight="regular"
                            fontSize={18}
                          >
                            {sellResult.instructions}
                          </Typography>
                        </Box>
                        <Box mt={3}>
                          <Button
                            onClick={() => {
                              // window.location.href = sellResult.instrument.redirect_url;
                              window
                                .open(
                                  sellResult.instrument.redirect_url,
                                  "_blank"
                                )
                                .focus();
                            }}
                            color="success"
                            variant="contained"
                            startIcon={<Icon>payment</Icon>}
                          >
                            Pay Now
                          </Button>
                        </Box>
                      </Box>
                    )}
                    <Box mt={5}>
                      {showInlineLoading && (
                        <Box mb={3}>
                          <Typography mb={1} fontSize={12}>
                            Checking payment status...
                          </Typography>
                          <LinearProgress color="info" />
                        </Box>
                      )}
                      <Button
                        color="success"
                        variant="outlined"
                        sx={{ width: "100%" }}
                        onClick={() => {
                          checkPayment(sellResult.reference);
                        }}
                      >
                        I have Paid
                      </Button>
                      <Box
                        mt={3}
                        onClick={() => {
                          if (
                            window.confirm(
                              "Are you sure you want to close?"
                            ) === true
                          ) {
                            window.location.reload();
                          }
                        }}
                      >
                        <Typography variant="h6" fontWeight="light">
                          [ x close ]
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </DialogContent>
            </Dialog>
          )}
          <Dialog open={openSuccessDialog} fullWidth maxWidth="xs">
            <DialogContent>
              <Box mt={3} align="center" mb={3}>
                <Box>
                  <Box mt={1}>
                    <Box sx={{ position: "relative", display: "inline-flex" }}>
                      <CircularProgress
                        variant="determinate"
                        size={120}
                        thickness={2}
                        color="success"
                        value={100}
                      />
                      <Box
                        sx={{
                          top: 0,
                          left: 0,
                          bottom: 0,
                          right: 0,
                          position: "absolute",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Icon color="success" fontSize="large">
                          check
                        </Icon>
                      </Box>
                    </Box>
                  </Box>
                </Box>
                <Box mt={2}>
                  <Typography variant="h6" fontWeight="light">
                    {errorMsg}
                  </Typography>
                </Box>
              </Box>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  setOpenSuccessDialog(false);
                  window.location.reload();
                }}
                color="primary"
                iconOnly
                circular
                variant="outlined"
              >
                <Icon>close</Icon>
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog open={openErrorDialog} fullWidth maxWidth="xs">
            <DialogContent>
              <Box mt={3} align="center" mb={3}>
                <Box>
                  <Box mt={1}>
                    <Box sx={{ position: "relative", display: "inline-flex" }}>
                      <CircularProgress
                        variant="determinate"
                        size={120}
                        thickness={2}
                        color="error"
                        value={100}
                      />
                      <Box
                        sx={{
                          top: 0,
                          left: 0,
                          bottom: 0,
                          right: 0,
                          position: "absolute",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Icon color="error" fontSize="large">
                          close
                        </Icon>
                      </Box>
                    </Box>
                  </Box>
                </Box>
                <Box mt={2}>
                  <Typography variant="h6" fontWeight="light">
                    {statusMsg}
                  </Typography>
                </Box>
              </Box>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  setOpenErrorDialog(false);
                }}
                color="primary"
                iconOnly
                circular
                variant="outlined"
              >
                <Icon>close</Icon>
              </Button>
            </DialogActions>
          </Dialog>

          {campaign !== null && (
            <Box sx={{ margin: "5px auto", maxWidth: "600px" }}>
              <Box>
                <Paper elevation={0}>
                  <Box p={2} align="center">
                    <Box>
                      <img
                        src={`${AppConfig.api_media_url}${banner}`}
                        alt="img"
                        style={{ maxWidth: "40%", maxHeight: "100%" }}
                      />
                    </Box>
                    <Box mt={3}>
                      <Typography variant="subtitle1" fontWeight={500}>
                        {campaign.account.name}
                      </Typography>
                    </Box>
                    <Box mt={1}>
                      <Typography variant="caption" fontWeight={350}>
                        {campaign.title}
                      </Typography>
                    </Box>
                  </Box>
                </Paper>
              </Box>
              {campaign.description.length > 0 && (
                <Box mt={3}>
                  <Paper elevation={3}>
                    <Box p={2}>
                      <Box>
                        <Typography variant="caption" fontWeight="bold">
                          DESCRIPTION
                        </Typography>
                      </Box>
                      <Box mt={2}>
                        <Typography variant="caption" fontSize={12}>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: campaign.description,
                            }}
                          />
                        </Typography>
                      </Box>
                    </Box>
                  </Paper>
                </Box>
              )}

              {dataForm !== null && (
                <form id="dataForm">
                  <Box>
                    {dataForm.form.form.sections.map((formSection) => {
                      let sect = <></>;
                      if (
                        formSection.reference in
                        dataForm.form.form.navigation_logic.listeners
                      ) {
                        const listener =
                          dataForm.form.form.navigation_logic.listeners[
                            formSection.reference
                          ];
                        const wID = `t_watcher_${listener.type}_${formSection.reference}`;
                        sect = (
                          <div id={`${wID}`} style={{ display: "none" }}>
                            <Box mt={5} mb={3}>
                              <Paper elevation={3}>
                                <Box px={3} py={3}>
                                  <FormSectionBuilder
                                    section={formSection}
                                    logic={dataForm.form.form.navigation_logic}
                                  />
                                </Box>
                              </Paper>
                            </Box>
                          </div>
                        );
                        setTimeout(async () => {
                          const parentField = document.getElementById(
                            `dff_${listener.trigger}`
                          );
                          parentField.addEventListener("change", function () {
                            const d = document.getElementById(wID);
                            if (parentField.value !== listener.control) {
                              d.style.display = "none";
                              formSection.fields.every((fld) => {
                                document.getElementById(
                                  `dff_${fld.reference}`
                                ).value = null;
                                return false;
                              });
                            } else {
                              d.style.display = "block";
                            }
                          });
                        }, 1000);
                      } else {
                        sect = (
                          <Box mt={5} mb={3}>
                            <Paper elevation={3}>
                              <Box px={3} py={3}>
                                <FormSectionBuilder
                                  section={formSection}
                                  logic={dataForm.form.form.navigation_logic}
                                />
                              </Box>
                            </Paper>
                          </Box>
                        );
                      }
                      return sect;
                    })}
                  </Box>
                </form>
              )}

              {presetAmount !== null && (
                <Box mt={5}>
                  <Paper elevation={3}>
                    <Box px={3} py={3}>
                      <Box>
                        <Typography variant="caption" fontWeight="bold">
                          PAYMENT INFORMATION
                        </Typography>
                        {presetAmount.amount_type === "FIXED" ? (
                          <Box mt={2} mb={3}>
                            <TextField
                              name="Amount"
                              margin="dense"
                              label={presetAmount.display_name}
                              readonly
                              fullWidth
                              variant="outlined"
                              value={selectedAmount.toLocaleString("en", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    {presetAmount.currency}
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </Box>
                        ) : (
                          <Box mt={2} mb={3}>
                            <TextField
                              name="Amount"
                              margin="dense"
                              label={presetAmount.display_name}
                              placeholder="Enter an amount"
                              type="decimal"
                              fullWidth
                              variant="outlined"
                              onChange={(e) => {
                                setAmount(e.target.value);
                              }}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    {presetAmount.currency}
                                  </InputAdornment>
                                ),
                              }}
                            />
                            <Box mt={0.5}>
                              <Grid container spacing={3}>
                                <Grid item xs={6} md={6} lg={6}>
                                  {presetAmount.minimum_amount !== null && (
                                    <Typography
                                      align="left"
                                      fontSize={10}
                                      px={1}
                                    >
                                      {`Minimum: ${presetAmount.currency}
                                      ${(
                                        presetAmount.minimum_amount / 100
                                      ).toLocaleString("en", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })}`}
                                    </Typography>
                                  )}
                                </Grid>
                                <Grid item xs={6} md={6} lg={6}>
                                  {presetAmount.maximum_amount !== null && (
                                    <Typography
                                      align="right"
                                      fontSize={10}
                                      px={1}
                                    >
                                      {`Maximum: ${presetAmount.currency}
                                      ${(
                                        presetAmount.maximum_amount / 100
                                      ).toLocaleString("en", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })}`}
                                    </Typography>
                                  )}
                                </Grid>
                              </Grid>
                            </Box>
                          </Box>
                        )}
                      </Box>
                      <Box mt={5} mb={3}>
                        <Typography variant="caption" fontWeight="bold">
                          PAYMENT METHOD
                        </Typography>
                        <Box mt={3}>
                          <TextField
                            fullWidth
                            select
                            label="How do you want to pay?"
                            onChange={(e) => {
                              setPaymentMethod(e.target.value);
                            }}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <Icon>payment</Icon>
                                </InputAdornment>
                              ),
                            }}
                          >
                            {
                              // --> Notice below changes
                              presetAmount.payment_methods.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                presetAmount.payment_methods.map((record) => (
                                  <MenuItem
                                    key={record.value}
                                    value={record.value}
                                  >
                                    {record.name}
                                  </MenuItem>
                                ))
                            }
                          </TextField>
                        </Box>
                      </Box>
                    </Box>
                  </Paper>
                </Box>
              )}

              <Box mt={7} align="center">
                <Button
                  size="large"
                  sx={{ width: { xs: "100%", md: "100%", lg: "100%" } }}
                  endIcon={<Icon>save</Icon>}
                  color="primary"
                  variant="contained"
                  onClick={() => {
                    capture();
                  }}
                >
                  Submit
                </Button>
              </Box>
            </Box>
          )}
        </Container>
      </Box>
      <CheckoutFooter />
    </>
  );
}

export default DataCapturePage;
